<template>
  <v-card width="400">
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title
            class="text-subtitle-1 mb-3 mt-2"
          >
            {{ $t('common.diligence_cloud') }} {{ $t('common.license') }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="modal">
          <v-icon
            @click="closeDialog()"
          >
            mdi-close
          </v-icon>
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle
            class="text-subtitle-2 my-1"
          >
            {{ $t('common.account') }}: <strong>{{ account.name }}</strong>
          </v-list-item-subtitle>
          <v-list-item-subtitle
            class="text-subtitle-2 my-1"
          >
            {{ $t('common.license_name') }}: <strong>{{ licenseName }}</strong>
          </v-list-item-subtitle>
          <v-list-item-subtitle
            class="text-subtitle-2 my-1"
          >
            {{ $t('common.license_level') }}: <strong>{{ licenseTitle }}</strong>
          </v-list-item-subtitle>
          <v-list-item-subtitle
            class="text-subtitle-2 my-1"
            hidden
          >
            {{ $t('common.license_type') }}: <strong>{{ licenseType }}</strong> / <strong>{{ licenseSubType }}</strong>
          </v-list-item-subtitle>
          <v-list-item-subtitle
            class="text-subtitle-2 my-1"
          >
            {{ $t('common.license_activated_at') }}: <strong>{{ licenseActivatedAt }}</strong>
          </v-list-item-subtitle>
          <v-list-item-subtitle
            class="text-subtitle-2 my-1"
            hidden
          >
            {{ $t('common.license_expires_at') }}: <strong>{{ licenseExpiresAt }}</strong>
          </v-list-item-subtitle>
          <v-btn
            @click="navigateToLicenses()"
            class="my-4"
          >
            {{ $t('common.license_view_or_change') }}
            <v-icon
              right
              dark
            >
              mdi-pencil
            </v-icon>
          </v-btn>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LICENSE_ENTERPRISE } from '../../../app';

export default {
  name: 'LicenseOverview',
  props: {
    modal: {
      Type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['license', 'licenseName', 'licenseLevel', 'account', 'formatDate']),
    licenseData() {
      return this.license && this.license.data && this.license.data.length ? this.license.data[0] : null;
    },
    licenseTitle() {
      return this.licenseLevel ? `${this.licenseLevel[0].toUpperCase()}${this.licenseLevel.slice(1)}` : this.account.license.license;
    },
    licenseType() {
      return this.license && this.license.type ? `${this.license.type[0].toUpperCase()}${this.license.type.slice(1)}` : 'Unknown';
    },
    licenseSubType() {
      return this.license && this.license.subtype ? `${this.license.subtype[0].toUpperCase()}${this.license.subtype.slice(1)}` : 'Unknown';
    },
    licenseActivatedAt() {
      return this.license && this.license.activated_at ? this.formatDate(this.license.activated_at) : 'Unknown';
    },
    licenseExpiresAt() {
      return this.licenseData && this.licenseData.access_expires && this.licenseData.access_expires > 0 ? this.formatDate(this.licenseData.access_expires * 1000) : 'Unknown';
    },
    licenseCanUpgrade() {
      return this.licenseLevel && this.licenseLevel !== LICENSE_ENTERPRISE;
    },
  },
  methods: {
    ...mapActions(['success', 'error']),
    navigateToLicenses() {
      this.$router.push({ name: 'account.license' });
      this.closeDialog();
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
  },
};
</script>

<style scoped>

</style>
